
import { useEffect, useState } from "react";

import { useDispatch, useSelector } from 'react-redux';

import { useNavigate } from "react-router";

import { RootState } from '../../store';

import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Switch, IconButton, TableFooter, TablePagination, Typography, Button, Grid, Dialog, DialogActions, DialogContent, TextField, CircularProgress, FormControl, InputLabel, Select, MenuItem, Paper } from "@mui/material"

import EditIcon from "@mui/icons-material/Edit";
import UndoIcon from '@mui/icons-material/Undo';

import { openSnackbar } from "../../store/slices/SnackbarSlice";

import { Layout } from "../../components/Layout"

import { SearchTextField } from "../../components/SearchTextField";

import { TablePaginationActions } from "../../helpers/TablePaginationActions";
import { usePages } from "../../hooks/usePages";

import { useFilter } from "../../hooks/useFilter";
import { TablePaddingStyle, TableTheadStyle } from '../../styles/TableStyle';

import { EstadoProps } from "../../interfaces/catalogos/EstadoInterface";

import { ActualizarEstado, AgregarEstado, Estados } from "../../connections/catalogos/EstadoConnection";
import { PaisProps } from "../../interfaces/catalogos/PaisInterface";
import { Pais } from "../../connections/catalogos/PaisConnection";
import { DialogActionsStyle, DialogContentStyle } from "../../styles/DialogStyle";

export const EstadoPage = () => {

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const { administrador } = useSelector( ( state: RootState ) => state.auth );

    const [EstadoArray, setEstadoArray] = useState<EstadoProps[]>([]);

    const [paisArray, setPaisArray] = useState<PaisProps[]>([]);

    const [pais, setPais] = useState<number>(0);

    const [openModal, setOpenModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [loadingData, setLoadingData] = useState(true);

    const [idEstado, setIdEstado] = useState(0);
    const [descripcion, setDescripcion] = useState('');

    const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage, resetPage } = usePages(5);

    const { filtro, setFiltro, dataFiltrada: dataFiltrada1 } = useFilter(EstadoArray, (item, filtro) => item.descripcion.toLowerCase().includes(filtro.toLowerCase()));
    const { filtro: filtroPais, setFiltro: setFiltroPais, dataFiltrada } = useFilter(dataFiltrada1, (item, filtro) => (item.pais?.descripcion ?? '').toLowerCase().includes(filtro.toLowerCase()));

    const handleChangeChecked = async (checked: boolean, id: number) => {

        const EstadoSelected = EstadoArray.find((elem) => elem.idEstado === id);

        if (EstadoSelected) {

            await ActualizarEstado({ ...EstadoSelected, activo: checked }).then(resp => {

                if (resp.idEstado) {

                    var newArray = EstadoArray.map((elem) => {

                        if (elem.idEstado === id) {
                            elem.activo = checked;
                        }

                        return elem;
                    });

                    setEstadoArray(newArray);

                    dispatch(openSnackbar({ message: 'Se actualizó el registro correctamente', variant: 'success' }));

                }

            });
        }

    }

    const handleGuardar = async () => {

        if (idEstado !== 0) {

            const EstadoSelected = EstadoArray.find((elem) => elem.idEstado === idEstado);

            if (EstadoSelected) {

                setLoading(true);

                await ActualizarEstado({ ...EstadoSelected, descripcion, idPais: pais }).then(resp => {

                    if (resp.idEstado) {

                        setTimeout(() => {

                            var newArray = EstadoArray.map((elem) => {

                                if (elem.idEstado === idEstado) {
                                    elem.descripcion = descripcion;
                                    elem.idPais = pais;
                                    elem.pais = resp.pais;
                                }

                                return elem;
                            });

                            setEstadoArray(newArray);
                            setOpenModal(false);
                            setLoading(false);

                            dispatch(openSnackbar({ message: 'Se actualizó el registro correctamente', variant: 'success' }));

                        }, 700);

                    }

                });
            }


        }
        else {

            const EstadosAdd: EstadoProps = {
                idEstado: 0,
                clave: '',
                descripcion,
                activo: true,
                idPais: pais,
            };

            setLoading(true);

            await AgregarEstado(EstadosAdd).then(resp => {

                if (resp.idEstado) {

                    setTimeout(() => {

                        setEstadoArray([...EstadoArray, resp]);
                        setOpenModal(false);
                        setLoading(false);

                        dispatch(openSnackbar({ message: 'Se agregó el estado correctamente', variant: 'success' }));

                    }, 700);

                }

            });

        }

    }

    useEffect(() => {

        async function obtener() {

            setLoadingData(true);
            setEstadoArray([]);

            await Estados().then(resp => {

                setTimeout(() => {

                    setEstadoArray(resp);
                    setLoadingData(false);

                }, 700);

            });

        }

        obtener();

    }, [])

    useEffect(() => {

        async function obtener() {

            setPaisArray([]);

            await Pais().then(resp => {

                setTimeout(() => {

                    setPaisArray(resp);

                }, 700);

            });

        }

        obtener();

    }, [])

    return (

        <Layout breadcrumbs={[{ text: 'Administración' }, { text: 'Catálogos' }, { text: 'Estado' }]} backgroundPaper={false}>

            <Grid container spacing={3} >

                <Grid size={{ xs: 6 }} textAlign={'start'}>

                    {
                        administrador
                        &&
                            <Button startIcon={<UndoIcon />} color="secondary" variant="text" sx={{ mt: 1 }} onClick={() => navigate('/')}>
                                Regresar
                            </Button>
                    }

                </Grid>

                <Grid size={{ xs: 6 }} textAlign={'end'}>

                    <Button
                        variant="contained"
                        sx={{ mt: 1 }}
                        disabled={loadingData}
                        onClick={() => {

                            setIdEstado(0);
                            setDescripcion('');
                            setPais(0)

                            setOpenModal(true);
                        }}
                    >
                        Agregar
                    </Button>

                </Grid>

            </Grid>

            <Grid container spacing={2} sx={{ mt: 2 }}>

                <Grid size={{ xs: 12, md: 6 }} textAlign={'start'}>

                    <SearchTextField
                        value={ filtro }
                        label="Buscar estado"
                        onChange={ ( value ) => {
                            setFiltro( value );
                            resetPage();
                        }}
                        onClear={ () => resetPage() }
                    />

                </Grid>

                <Grid size={{ xs: 12, md: 6 }} textAlign={'start'}>

                    <SearchTextField
                        value={ filtroPais }
                        label="Buscar por país"
                        onChange={ ( value ) => {
                            setFiltroPais( value );
                            resetPage();
                        }}
                        onClear={ () => resetPage() }
                    />

                </Grid>

            </Grid>

            <TableContainer sx={{ mt: 3, borderRadius: 3 }} component={Paper}>

                <Table sx={{ minWidth: 500 }}>

                    <TableHead sx={{ ...TableTheadStyle }}>

                        <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>

                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%', textAlign: 'center' }}> Id </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%' }}> Clave </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '25%' }}> Descripción </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%' }}> País </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%' }}>  </TableCell>

                        </TableRow>

                    </TableHead>

                    <TableBody>

                        {
                            (
                                rowsPerPage > 0
                                    ?
                                    dataFiltrada.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    :
                                    dataFiltrada
                            )
                                .map(({ idEstado, descripcion, clave, activo, idPais, pais }) => (

                                    <TableRow key={idEstado} >

                                        <TableCell sx={{ fontWeight: 'bold', textAlign: 'center' }}>
                                            {idEstado}
                                        </TableCell>

                                        <TableCell>
                                            {clave}
                                        </TableCell>

                                        <TableCell>
                                            {descripcion}
                                        </TableCell>

                                        <TableCell>
                                            {pais?.descripcion}
                                        </TableCell>

                                        <TableCell sx={{ textAlign: 'end' }}>

                                            <Switch
                                                checked={activo}
                                                onChange={(e) => handleChangeChecked(e.target.checked, idEstado)}
                                            />

                                            <IconButton
                                                color="primary"
                                                aria-label="edit"
                                                component="span"
                                                onClick={() => {

                                                    setIdEstado(idEstado);
                                                    setPais(idPais);
                                                    setDescripcion(descripcion);

                                                    setOpenModal(true);
                                                }}
                                            >
                                                <EditIcon />
                                            </IconButton>

                                        </TableCell>

                                    </TableRow>

                                ))
                        }

                        {
                            (dataFiltrada.length === 0 && !loadingData)
                                ?
                                <TableRow style={{ height: 73 }}>

                                    <TableCell colSpan={7} align="center">

                                        <Typography variant="caption" color='secondary'> No se encontraron resultados </Typography>

                                    </TableCell>

                                </TableRow>
                                :
                                loadingData
                                &&
                                <TableRow style={{ height: 73 }}>

                                    <TableCell colSpan={7} align="center">

                                        <CircularProgress size={32} />

                                    </TableCell>

                                </TableRow>
                        }

                    </TableBody>

                    <TableFooter>

                        {
                            dataFiltrada.length !== 0
                            &&
                            <TableRow>

                                <TableCell colSpan={2} sx={{ border: 'none' }}>
                                    <Typography variant='body2' color='black' sx={{ fontWeight: 'bold' }}>
                                        Total de registros: {EstadoArray.length}
                                    </Typography>
                                </TableCell>

                                <TablePagination
                                    sx={{ border: 'none' }}
                                    rowsPerPageOptions={[5, 10, 20, 50, 100]}
                                    colSpan={8}
                                    count={dataFiltrada.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}

                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}

                                    ActionsComponent={TablePaginationActions}

                                    labelRowsPerPage="Filas por página"
                                    labelDisplayedRows={
                                        ({ from, to, count }) => {
                                            return '' + from + '-' + to + ' de ' + count
                                        }
                                    }
                                />

                            </TableRow>
                        }

                    </TableFooter>

                </Table>

            </TableContainer>

            <Dialog open={openModal} maxWidth='sm' fullWidth={true}>

                <DialogContent sx={DialogContentStyle}>

                    <Grid container spacing={3} sx={{ mt: 3 }}>

                        <Grid size={{ md: 12, xs: 12 }}>
                            <FormControl fullWidth>
                                <InputLabel>pais</InputLabel>

                                <Select
                                    label={'Pais'}
                                    value={pais}
                                    onChange={(e) => { setPais(e.target.value ?? 0); }}
                                >
                                    <MenuItem key={0} value={0}>Selecciona una opción</MenuItem>
                                    {
                                        paisArray.map((elem) => (
                                            <MenuItem key={elem.idPais} value={elem.idPais}> {elem.descripcion} </MenuItem>
                                        ))
                                    }
                                </Select>


                            </FormControl>
                        </Grid>

                        <Grid size={{ md: 12, xs: 12 }}>
                            <TextField
                                label={'Descripción'}
                                variant="outlined"
                                multiline
                                rows={4}
                                fullWidth
                                value={descripcion}
                                onChange={(e) => setDescripcion(e.target.value)}
                                slotProps={{
                                    input: {
                                        autoComplete: 'off'
                                    },
                                    inputLabel: {
                                        shrink: true,
                                    }
                                }}
                            />
                        </Grid>

                    </Grid>

                </DialogContent>

                <DialogActions sx={DialogActionsStyle}>
                    <Button color="secondary" disabled={loading} onClick={() => setOpenModal(false)}> Cancelar </Button>
                    <Button loading={loading} disabled={descripcion === '' || pais === 0} onClick={handleGuardar} variant='contained'> Guardar </Button>
                </DialogActions>

            </Dialog>

        </Layout>

    )
}